import { z } from 'zod';

export const searchCategorySchema = z.object({
  slug: z.string(),
  title: z.string(),
});

export type SearchCategory = z.infer<typeof searchCategorySchema>;

export const searchBookSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  coverUrl: z.string().optional(),
  author: z.string().optional(),
  teaser: z.string().optional(),
  url_slug: z.string().nullish(),
  publisher: z.string().nullable().optional(),
});

export type SearchBook = z.infer<typeof searchBookSchema>;

export const searchReadingListSchema = z.object({
  id: z.number(),
  title: z.string(),
  storiesCount: z.number().optional(),
});

export type SearchReadingList = z.infer<typeof searchReadingListSchema>;

export const searchAutocompleteResponse = z.object({
  books: z.array(searchBookSchema),
  categories: z.array(searchCategorySchema),
  readingLists: z.array(searchReadingListSchema).optional(),
});

export type SearchAutocompleteResponse = z.infer<typeof searchAutocompleteResponse>;

export const searchResultsResponse = z.object({
  books: z.array(searchBookSchema),
  pagination: z.object({
    currentPage: z.number(),
    itemsPerPage: z.number(),
    currentPageItems: z.number(),
    isLastPage: z.boolean(),
    totalItems: z.number(),
  }),
});

export type SearchResultsResponse = z.infer<typeof searchResultsResponse>;
